import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import './CouponUsage.css';

const CouponUsage = () => {
  const { couponId } = useParams();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('weight-loss');
  const [couponUsageData, setCouponUsageData] = useState([]);
  const [bulkCouponUsageData, setBulkCouponUsageData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [bulkLoading, setBulkLoading] = useState(true);
  const [error, setError] = useState('');
  const [bulkError, setBulkError] = useState('');

  useEffect(() => {
    fetchCouponUsage();
  }, [couponId]);

  useEffect(() => {
    fetchBulkCouponUsage();
  }, [couponId]);

  const fetchCouponUsage = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`https://gokulnair.com/new_project/api/orders/coupon/${couponId}`);
      if (response.data.success) {
        setCouponUsageData(response.data.data);
      } else {
        setCouponUsageData([]);
      }
    } catch (err) {
      console.error('Error fetching coupon usage:', err);
      setError('Failed to fetch coupon usage data');
      setCouponUsageData([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchBulkCouponUsage = async () => {
    try {
      setBulkLoading(true);
      const response = await axios.get(`https://gokulnair.com/rpo_bulk/api/orders/coupon/${couponId}`);
      if (response.data.success) {
        setBulkCouponUsageData(response.data.data);
      } else {
        setBulkCouponUsageData([]);
      }
    } catch (err) {
      console.error('Error fetching bulk coupon usage:', err);
      setBulkError('Failed to fetch bulk coupon usage data');
      setBulkCouponUsageData([]);
    } finally {
      setBulkLoading(false);
    }
  };

  const getPaymentStatusText = (status) => {
    switch (parseInt(status)) {
      case 0: return 'Pending';
      case 1: return 'Confirmed by User';
      case 2: return 'Confirmed by Admin';
      case 3: return 'Rejected by Admin';
      case 4: return 'Rejected by User';
      default: return 'Unknown';
    }
  };

  const getPaymentStatusClass = (status) => {
    switch (parseInt(status)) {
      case 0: return 'status-pending';
      case 1: return 'status-confirmed-user';
      case 2: return 'status-confirmed-admin';
      case 3: return 'status-rejected-admin';
      case 4: return 'status-rejected-user';
      default: return 'status-pending';
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const handleBackClick = () => {
    navigate('/coupons');
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  if (loading && bulkLoading) {
    return (
      <div className="coupon-usage-page">
        <div className="page-header">
          <button onClick={handleBackClick} className="back-btn">
            ← Back to Coupons
          </button>
          <h1>Coupon Usage Details</h1>
        </div>
        <div className="loading-container">
          <div className="loading">Loading coupon usage data...</div>
        </div>
      </div>
    );
  }

  if (error && bulkError) {
    return (
      <div className="coupon-usage-page">
        <div className="page-header">
          <button onClick={handleBackClick} className="back-btn">
            ← Back to Coupons
          </button>
          <h1>Coupon Usage Details</h1>
        </div>
        <div className="error-container">
          <div className="error-message">Failed to load coupon usage data</div>
        </div>
      </div>
    );
  }

  return (
    <div className="coupon-usage-page">
      <div className="page-header">
        <button onClick={handleBackClick} className="back-btn">
          ← Back to Coupons
        </button>
        <h1>Coupon Usage Details</h1>
        <div className="coupon-info">
          <span className="coupon-id">Coupon ID: {couponId}</span>
        </div>
      </div>

      <div className="page-content">
        {/* Tabs */}
        <div className="coupon-usage-tabs">
          <button
            className={`tab-button ${activeTab === 'weight-loss' ? 'active' : ''}`}
            onClick={() => handleTabChange('weight-loss')}
          >
            RPO Weight Loss
          </button>
          <button
            className={`tab-button ${activeTab === 'bulk' ? 'active' : ''}`}
            onClick={() => handleTabChange('bulk')}
          >
            RPO Bulk
          </button>
        </div>

        {/* RPO Weight Loss Tab Content */}
        {activeTab === 'weight-loss' && (
          <>
            {loading ? (
              <div className="loading-container">
                <div className="loading">Loading RPO Weight Loss coupon usage data...</div>
              </div>
            ) : error ? (
              <div className="error-container">
                <div className="error-message">{error}</div>
              </div>
            ) : (
              <>
                {couponUsageData && couponUsageData.length > 0 ? (
                  <>
                    <div className="usage-stats">
                      <div className="stat-card">
                        <h3>Total Orders (RPO Weight Loss)</h3>
                        <p className="stat-number">{couponUsageData.length}</p>
                      </div>
                    </div>

                    <div className="orders-section">
                      <h2>Orders Using This Coupon (RPO Weight Loss)</h2>
                      <div className="orders-table-container">
                        <table className="orders-table">
                          <thead>
                            <tr>
                              <th>Order ID</th>
                              <th>Customer</th>
                              <th>Email</th>
                              <th>Phone</th>
                              <th>Products</th>
                              <th>Payment Status</th>
                              <th>Order Date</th>
                            </tr>
                          </thead>
                          <tbody>
                            {couponUsageData.map((order) => (
                              <tr key={order.id}>
                                <td>{order.order_id}</td>
                                <td>{order.name}</td>
                                <td className="email-cell">{order.email}</td>
                                <td>{order.phone}</td>
                                <td>
                                  <div className="product-skus">
                                    {order.sku.split(',').map((sku, index) => (
                                      <span key={index} className="sku-badge">{sku.trim()}</span>
                                    ))}
                                  </div>
                                </td>
                                <td>
                                  <span className={`status-badge ${getPaymentStatusClass(order.payment_status)}`}>
                                    {getPaymentStatusText(order.payment_status)}
                                  </span>
                                </td>
                                <td>{formatDate(order.created_at)}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </>
                ) : (
                  <div className="no-usage">
                    <div className="no-usage-content">
                      <h3>No Orders Found</h3>
                      <p>This coupon has not been used in any RPO Weight Loss orders yet.</p>
                    </div>
                  </div>
                )}
              </>
            )}
          </>
        )}

        {/* RPO Bulk Tab Content */}
        {activeTab === 'bulk' && (
          <>
            {bulkLoading ? (
              <div className="loading-container">
                <div className="loading">Loading RPO Bulk coupon usage data...</div>
              </div>
            ) : bulkError ? (
              <div className="error-container">
                <div className="error-message">{bulkError}</div>
              </div>
            ) : (
              <>
                {bulkCouponUsageData && bulkCouponUsageData.length > 0 ? (
                  <>
                    <div className="usage-stats">
                      <div className="stat-card">
                        <h3>Total Orders (RPO Bulk)</h3>
                        <p className="stat-number">{bulkCouponUsageData.length}</p>
                      </div>
                    </div>

                    <div className="orders-section">
                      <h2>Orders Using This Coupon (RPO Bulk)</h2>
                      <div className="orders-table-container">
                        <table className="orders-table">
                          <thead>
                            <tr>
                              <th>Order ID</th>
                              <th>Customer</th>
                              <th>Email</th>
                              <th>Phone</th>
                              <th>Products</th>
                              <th>Payment Status</th>
                              <th>Order Date</th>
                            </tr>
                          </thead>
                          <tbody>
                            {bulkCouponUsageData.map((order) => (
                              <tr key={order.id}>
                                <td>{order.order_id}</td>
                                <td>{order.name}</td>
                                <td className="email-cell">{order.email}</td>
                                <td>{order.phone}</td>
                                <td>
                                  <div className="product-skus">
                                    {order.sku.split(',').map((sku, index) => (
                                      <span key={index} className="sku-badge">{sku.trim()}</span>
                                    ))}
                                  </div>
                                </td>
                                <td>
                                  <span className={`status-badge ${getPaymentStatusClass(order.payment_status)}`}>
                                    {getPaymentStatusText(order.payment_status)}
                                  </span>
                                </td>
                                <td>{formatDate(order.created_at)}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </>
                ) : (
                  <div className="no-usage">
                    <div className="no-usage-content">
                      <h3>No Orders Found</h3>
                      <p>This coupon has not been used in any RPO Bulk orders yet.</p>
                    </div>
                  </div>
                )}
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default CouponUsage;